/* ============================================================
   レビュー記事 共通スクリプト（2610_nutripe_monitor.js・2610 NUTRIPEモニター記事 全5ページ共通）

   Shopify管理画面 → テーマ → コードを編集 → assets に
   「2610_nutripe_monitor.js」の名前でアップロードしてください。

   やっていること：
   ・class="ntp-article_202608-open" の要素をタップ → 商品情報シートを開く
     - data-sheet="シートのid" で、どのシートを開くか指定できます
       例）<a class="ntp-article_202608-open" data-sheet="ntp-article_202608-sheet-dry">ドライフード</a>
     - data-sheet がない場合は、ページ内の最初のシートを開きます
   ・×ボタン／背景の暗幕／Escキー → シートを閉じる
   ・シートはページ内に何個置いてもOK（商品の数だけ増やせます）
   ============================================================ */

(function () {

  function init() {
    var overlay = document.getElementById('ntp-article_202608-overlay');
    var sheets  = document.querySelectorAll('.ntp-article_202608-sheet');

    /* シートを置いていないページでは何もしない */
    if (!overlay || sheets.length === 0) return;

    function closeAll() {
      sheets.forEach(function (sheet) {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
      });
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function openSheet(e) {
      e.preventDefault();
      closeAll();   /* 別のシートが開いていたら先に閉じる */

      /* data-sheet で指定されたシートを開く（指定がなければ最初のシート） */
      var id     = e.currentTarget.getAttribute('data-sheet');
      var target = id ? document.getElementById(id) : sheets[0];
      if (!target) return;

      target.classList.add('is-open');
      target.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';   /* 背面スクロールを止める */
    }

    /* class="ntp-article_202608-open" を付けた要素すべてが「開くボタン」になります */
    document.querySelectorAll('.ntp-article_202608-open').forEach(function (el) {
      el.addEventListener('click', openSheet);
    });

    /* 各シートの×ボタン */
    document.querySelectorAll('.ntp-article_202608-sheet-close').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });

    overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ページの読み込みが終わってから動かす */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
